<template>
  <b-container class="home-container container-xl">
    <b-row col="12" class="mb-4 text-left">
      <b-col sm="12" md="12" lg="9" xl="9">
        <h1 class="mb-4">MGFÜ Energetikai Tanácsadási Voucher Program</h1>
        <p class="mb-4">
          <strong>
            Az MGFÜ Energetikai Tanácsadási Voucher Program című címzetti felhívás keretében a támogatási kérelmek
            benyújtása 2025. december 5-én lezárult.
          </strong>
        </p>
        <p>
          A felhívás keretében energetikai tanácsadási szolgáltatások igénybevételére nyílt lehetőség azon, nyertes
          mikro-, kis- és középvállalkozások számára, amelyek Magyarország területén székhellyel, telephellyel vagy
          fiókteleppel rendelkeznek.
        </p>
        <p>
          <i>
            Az MGFÜ Energetikai Tanácsadási Voucher Program a GINOP Plusz-1.1.1-22-2022-00001 azonosító számú, „Célzott
            vállalkozásfejlesztési szolgáltatások biztosítása mikro-, kis- és középvállalkozások számára” című projekt
            részeként valósul meg, a Széchenyi Terv Plusz program keretében, az Európai Unió támogatásával.
          </i>
        </p>
        <!-- <p class="mb-4">
          <strong>
            Az „MGFÜ Energetikai Tanácsadási Voucher Program” című címzetti felhívás keretében támogatási kérelmet 2024.
            május 2. 12:00 órától 2025. december 5. 12:00-ig lehet benyújtani.
          </strong>
        </p>
        <p>
          A felhívás energetikai tanácsadási szolgáltatások igénybevételére biztosít lehetőséget azon mikro-, kis-, és
          középvállalkozásoknak, amelyek Magyarország területén székhellyel, telephellyel vagy fiókteleppel
          rendelkeznek.
        </p>
        <p>
          A rendelkezésre álló tervezett keretösszeg 400 millió forint.
        </p>
        <p>
          <strong>
            2025. március 25-én a Címzetti Felhívás az alábbi pontokban módosult:
          </strong>
        </p>
        <li style="list-style-position: inside;">
          A „Rövid összefoglaló” és „4.3. Mikor lehet benyújtani a támogatási kérelmet?” pontokban dátum módosítás
          történt: a beadási határidő 2025.03.31. 12:00-ról 2025.12.05. 12:00-ra változott.
        </li>
        <li style="list-style-position: inside;">
          A „8.5.2 A Támogatói Okirat módosítása” pont kiegészítésre került egy bekezdéssel: „A Kedvezményezett köteles
          8 napon belül nyilatkozni a támogatói okirat tartalmát befolyásoló változásokról, emellett köteles benyújtani
          minden olyan alátámasztó dokumentumot, amelynek tartalmában változás történt.”
        </li> -->
        <!--p class="mb-0">
          <strong>
            A módosítással érintett pontok:
          </strong>
        </p>
        <div class="p-3">
          <li>8.7.3.1. „A szakmai beszámoló elfogadása”</li>
          <li>8.8.1. „Számla kiállítása”</li>
          <li>8.8.2.3. „Számla”</li>
        </div-->
        <!-- <p>
          <i>
            Az MGFÜ Energetikai Tanácsadás Voucher Program a GINOP Plusz-1.1.1-22-2022-00001 azonosító számú, Célzott
            vállalkozásfejlesztési szolgáltatások biztosítása mikro-, kis- és középvállalkozások számára című projekt
            részeként kerül lebonyolításra a Széchenyi Terv Plusz program keretében, az Európai Unió támogatásával.
          </i>
        </p> -->
        <b-row>
          <b-col lg="5">
            <b-button
              variant="primary"
              href="https://voucher.mgfu.hu/kau-login"
              target="_blank"
              class="d-flex align-items-center justify-content-center my-1 my-lg-0"
            >
              Tovább a pályázat kitöltő felületre
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="text-left my-5">
      <b-col lg="9">
        <h2>Támogatáshoz kapcsolódó dokumentumok</h2>
      </b-col>
    </b-row>
    <b-row id="doc_downloads" cols="12" class="text-left mb-4">
      <b-col lg="6">
        <p class="mb-4"><strong>Letölthető dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0325.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/adatkezelesi_tajekoztato.pdf"
              >
                Adatkezelési tájékoztató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_tvi_utmutato.pdf"
              >
                TVI útmutató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Energetikai_Voucher_Program_GYIK.pdf"
              >
                Gyakori kérdések
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/tanacsadasi_naplo_voucher.docx"
              >
                Tanácsadási napló sablon
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Hatalyos_TO_ETVP_20260330.pdf"
              >
                Támogatott vállalkozások
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
    <b-row id="doc_downloads" cols="12" class="text-left mb-4">
      <b-col lg="6">
        <p class="mb-4"><strong>Archív dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0415.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.04.15
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0527.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.05.27
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0715.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.07.15
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0801.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.08.01
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_1016.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.10.16
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_1204.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.12.04
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_1213.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2024.12.13
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href=": https://vali.hu/static/MGFU_voucher_cimzetti_felhivas_0110.pdf"
              >
                Címzetti felhívás - MGFÜ Energetikai Tanácsadási Voucher Program 2025.01.10
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
    <b-row class="text-left my-5">
      <b-col lg="9">
        <h2>
          Zöld vállalati folyamatok és működés, valamint jelentéstétel tanácsadási kategóriában minősített szakértők
        </h2>
      </b-col>
    </b-row>
    <b-row v-for="(expert, index) in experts" :key="index" class="d-flex">
      <b-col @click="handleOpenLinkInNewTab(expert.link)" cols="12" class="expert-container mb-3">
        <b-row class="expert-wrapper">
          <b-col cols="4" class="expert-image-wrapper">
            <img :src="expert.logo" class="expert-image" />
          </b-col>
          <b-col cols="8" class="expert-title">
            <h3>
              {{ expert.name }}
            </h3>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <i class="d-block text-left mt-5"
      >A 2023. évi IFKA Tanácsadási Voucher Program dokumentumai az alábbi linken érhetők el:
      <a href="https://vali.hu/voucher-program" target="_blank"> https://vali.hu/voucher-program</a></i
    >
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      experts: [
        {
          logo: require('../assets/img/szakertok/bdo_logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4874',
          name: 'BDO Magyarország ESG Tanácsadó Korlátolt Felelősségű Társaság'
        },
        /* {
          logo: require('../assets/img/szakertok/blyxa_consulting.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4625',
          name: 'Blyxa Consulting Fejlesztési és Innovációs Tanácsadó Korlátolt Felelősségű Társaság'
        }, */
        {
          logo: require('../assets/img/szakertok/bomo_logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4839',
          name: 'BOMO ENERGY Korlátolt felelősségű társaság'
        },
        /* {
          logo: require('../assets/img/szakertok/danuvia.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/1081',
          name: 'Danuvia Stúdió Oktató és Szolgáltató Korlátolt Felelősségű Társaság'
        }, */
        /* {
          logo: require('../assets/img/szakertok/e2_logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4858',
          name: 'E2 Hungary Energiakereskedelmi és Szolgáltató Zártkörűen Működő Részvénytársaság'
        }, */
        {
          logo: require('../assets/img/szakertok/electrosun.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4788',
          name: 'ElectroSun Szolgáltató és Kereskedelmi Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/enet.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/1111',
          name: 'eNET Magyarország Tanácsadó Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/ernts.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4867',
          name: 'Ernst & Young Könyvvizsgáló Korlátolt Felelősségű Társaság'
        },
        /* {
          logo: require('../assets/img/szakertok/exante.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4786',
          name: 'Ex Ante Tanácsadó Iroda Korlátolt Felelősségű Társaság'
        }, */
        {
          logo: require('../assets/img/szakertok/cegtuning.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/3216',
          name: 'ÉRTŐ Szolgáltató és Kereskedelmi Korlátolt Felelősségű Társaság'
        },
        /* {
          logo: require('../assets/img/szakertok/goodwill.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4812',
          name: 'GoodWill Energy Zártkörűen Működő Részvénytársaság'
        }, */
        {
          logo: require('../assets/img/szakertok/grant-thornton-logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4857',
          name: 'Grant Thornton Consulting Korlátolt Felelősségű Társaság'
        },
        /* {
          logo: require('../assets/img/szakertok/itim.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4774',
          name: 'ITI Magyarország Intelligens Technológia és Infrastruktúra Korlátolt Felelősségű Társaság'
        }, */
        {
          logo: require('../assets/img/szakertok/kpmg.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/1015',
          name: 'KPMG Tanácsadó Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/mn6.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4789',
          name: 'MN6-Energiaügynökség Szolgáltató Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/msg-plaut-logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4875',
          name: 'msg Plaut Hungary Kft.'
        },
        {
          logo: require('../assets/img/szakertok/otp.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/3516',
          name: 'OTP Hungaro-Projekt Pénzügyi Műszaki-Gazdasági Tanácsadó és Szervező Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/p2m-logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4876',
          name: 'p2m Informatika Szolgáltató Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/protamin.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/3948',
          name: 'PROTAMIN Szolgáltató Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/sg_opus_logo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/3945',
          name: 'SG Opus Consulting Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/SolpopLogo.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4830',
          name: 'SOL-POP Szolgáltató és Kereskedelmi Zártkörűen Működő Részvénytársaság'
        },
        {
          logo: require('../assets/img/szakertok/solver.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4720',
          name: 'SolverEnergy Energetikai Kivitelező és Szolgáltató Korlátolt Felelősségű Társaság'
        },
        {
          logo: require('../assets/img/szakertok/wattler.jpg'),
          link: 'https://vali.mgfu.hu/hu/experts/item/4794',
          name: 'Wattler Korlátolt Felelősségű Társaság'
        }
      ]
    }
  },
  methods: {
    handleOpenLinkInNewTab(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
ul {
  list-style-image: url('../assets/img/icons/tick_mark.svg');
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

.containers-svg {
  width: 100%;
  height: auto;
}

@media (max-width: 575px) {
  h1 {
    font-size: 24px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-size: 10px;
    font-weight: 700;
  }
}

.expert-container {
  height: 100px;
}

.expert-container:hover {
  background-color: #f2f8fa;
}

.expert-wrapper {
  cursor: pointer;
  height: 100%;
}

.expert-image-wrapper {
  height: 100%;
}

.expert-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.expert-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
h3 {
  font-size: 16px;
}
</style>
